<template>
  <section class="">
    <Join
      :eventId="$route.params.eventId"
      :eventName="$route.params.eventName"
    />
  </section>
</template>

<script>
import Join from "./Join.vue";

export default {
  name: "JoinEvent",
  props: ["eventId", "eventName"],
  components: {
    Join,
  },
};
</script>
